import { Button, HStack, Image, Text, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

interface joinCardType {
  title: string;
  description: string;
  image: string;
  role: number;
}

const JoinCard = ({ title, description, image, role }: joinCardType) => {
  const navigate = useNavigate();

  const goToRegister = () => {
    navigate("/register");
  };

  const goToGuide = () => {
    if (role === 2) {
      navigate("/guide/reseller");
    } else {
      navigate("/guide/supplier");
    }
  };

  return (
    <HStack
      maxW={{ base: "full", md: "750px", lg: "auto" }}
      justifyContent={"space-between"}
      gap={{ base: "24px", lg: "36px" }}
    >
      <Image
        src={image ? image : ""}
        display={{ base: "none", sm: "block" }}
        w={{ base: "100px", sm: "120px", md: "160px", xl: "232px" }}
        h={{ base: "100px", sm: "120px", md: "160px", xl: "232px" }}
        objectFit={"cover"}
        alt="Card Join"
      />

      <VStack
        align={"start"}
        maxW={{ base: "auto", lg: "350px" }}
        gap={{ base: "4px", xl: "12px" }}
      >
        <Text as={"h3"} textStyle={"h-title"}>
          Gabung Jadi {title}
        </Text>

        <Text as={"p"} textStyle={"b-reg"} variant={"secondary"}>
          {description}
        </Text>

        <HStack mt={{ base: "8px", md: "16px", xl: "20px" }}>
          <Button
            variant={"outline"}
            border={"solid 1.5px #F56565"}
            color={"red.400"}
            size={["xs", null, "sm"]}
            fontSize={[10, null, 12]}
            onClick={goToGuide}
          >
            Pelajari &gt;&gt;
          </Button>

          <Button
            bg={"red.400"}
            size={["xs", null, "sm"]}
            fontSize={[10, null, 12]}
            color={"white"}
            onClick={goToRegister}
          >
            Daftar {title}
          </Button>
        </HStack>
      </VStack>
    </HStack>
  );
};

export default JoinCard;
